import { PlayerRepository } from "../../../../data/repository/player/PlayerRepository";
import { ResponseState, State } from "../../../model/ResponseState";
import { Player } from "../../../model/User";

export interface PlayerGetCurrentInfoUseCase {
  invoke: () => Promise<ResponseState<Player>>;
}

export class PlayerGetCurrentInfoUseCaseImpl implements PlayerGetCurrentInfoUseCase {
  private playerRepository: PlayerRepository;

  constructor(playerRepository: PlayerRepository) {
    this.playerRepository = playerRepository;
  }

  async invoke(): Promise<ResponseState<Player>> {
    try {
      let response = await this.playerRepository.getCurrentUserInfo();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
